import React, { useState } from 'react'
import useFetch from '../../../hooks/useAxios';
import MyConuterRecents from './MyCounter/MyConuterRecents'
import MyCounterHeader from './MyCounter/MyCounterHeader';
import MyCounterStatics from './MyCounter/MyCounterStatics'

const MyCounter = () => {
  const [dahsboardInfo, setDashboardInfo] = useState()
  const fetchDashboard = useFetch({
    method: "get",
    url: "api/host/dashboard",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setDashboardInfo(res.data)
      
    }
  });
  return (
   <div>
    {dahsboardInfo &&  <div>
      <MyCounterHeader/> 
      <MyCounterStatics dahsboardInfo={dahsboardInfo} />
      <MyConuterRecents dahsboardInfo={dahsboardInfo}/>
    </div>}
   </div>
  )
}

export default MyCounter